import React from "react";
import StoryListCard from "./story-list-card";
import { GameStatus } from "../../../../types/game-status";
import { useAppSelector } from "../../../../redux/store";
import FormPage from "../../../common/formpage/formpage";
import { useFormValidation } from "../../../../hooks/useFormValidation";
import { useDisplayForm } from "../../../../hooks/useDisplayForm";
import { useTranslation } from "react-i18next";

type Props = {
  // onClick: (story: Story) => void
  onClick: (storyIndex: number) => void;
  onVote: () => void;
};

const StoryList = ({ onClick, onVote }: Props) => {
  const gameState = useAppSelector((state) => state.game);
  const playerState = useAppSelector((state) => state.player);

  const { t } = useTranslation("game");

  function handleClick(storyIndex: number) {
    onClick(storyIndex);
  }

  function handleVote() {
    onVote();
  }

  const { isReady } = useFormValidation({
    validationRules: [
      {
        validate: () =>
          playerState.player?.status_str === GameStatus.GameStatusVoting,
      },
    ],
    dependencies: [playerState.player?.status_str],
  });

  function subheaders() {
    const lines = [];
    if (playerState.player?.data.audience) {
      lines.push(t("storyList.subheaders.audience1"));
      lines.push(t("storyList.subheaders.audience2"));
      lines.push(t("storyList.subheaders.audience3"));
    } else {
      lines.push(t("storyList.subheaders.slam"));
      lines.push(t("storyList.subheaders.read"));
      lines.push(t("storyList.subheaders.proceed"));
    }

    lines.push(t("storyList.subheaders.accelerate"));

    return lines;
  }

  const { formPageProps } = useDisplayForm({
    customSubmit: handleVote,
    titles: [t("storyList.headers.default")],
    submitText:
      gameState.game?.players.length === 2 && !playerState.player?.data.audience
        ? t("storyList.footers.proceed")
        : t("storyList.footers.proceed"),
    validation: { isReady },
    readyFlash: true,
    countdownThreshold: 120,
    subHeaders: subheaders(),
  });

  return (
    <FormPage {...formPageProps}>
      <div className={"grow flex flex-col space-y-2 m-4"}>
        {gameState.game?.stories?.map<React.ReactNode>((s, idx) => (
          <StoryListCard
            key={"storylistcard-" + s.id}
            onClick={() => handleClick(idx)}
            story={s}
          />
        ))}
      </div>
    </FormPage>
  );
};

export default StoryList;
